import React from 'react';
import { NoResultsFilters1 } from '@alefeducation/ui-elements-library-icons';
import './no-data.scss';

interface NoDataPropsType {
  message?: string;
  testId?: string;
}

const NoData = (props: NoDataPropsType) => {
  const { message = 'No Data Found', testId = 'no-data-found' } = props;

  return (
    <div className="no-data-found" data-testid={testId}>
      <NoResultsFilters1 />
      <span>{message}</span>
    </div>
  );
};

export default NoData;
